import { render, staticRenderFns } from "./fzIndex.vue?vue&type=template&id=4fce80b6"
import script from "./fzIndex.vue?vue&type=script&lang=js"
export * from "./fzIndex.vue?vue&type=script&lang=js"
import style0 from "./fzIndex.vue?vue&type=style&index=0&id=4fce80b6&prod&lang=css"
import style1 from "./fzIndex.vue?vue&type=style&index=1&id=4fce80b6&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports